import React from "react";
import { Flex } from "@chakra-ui/react";
import Target from "./Target";
import { Analytics, Goal } from "../../services/documentService";

type TargetsContainerProps = {
	goals: Goal[];
	analytics: Analytics;
};

export const TargetsContainer = ({ goals, analytics }: TargetsContainerProps) => {
	return (
		<Flex direction="column" gap="12px">
			{goals.map(goal => {
				return <Target goal={goal} key={goal.id} analytics={analytics}/>;
			})}
		</Flex>
	);
};

export default TargetsContainer;